module.exports = __webpack_public_path__ + "20250721160708/img/help_icon.fc424ebb.png";